import countrySettings from '../countrySettings.json';
import PatientsAndServicesCL from './PatientsAndServicesCL';
import PatientsAndServicesPE from './PatientsAndServicesPE';

const COMPONENTS = { CL: PatientsAndServicesCL, PE: PatientsAndServicesPE };

const PatientsAndServices = (props) => {
  const variant = countrySettings.componentVariant.patientsAndServices[props.countryCode] ?? 'CL';
  const Component = COMPONENTS[variant];
  return <Component {...props} />;
};

export default PatientsAndServices;